import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Thankyou() {
  const navigate = useNavigate();
  const [logo, setLogo] = useState("/img/flipkart-logo.webp");

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      navigate("/home", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch("/webcontrollerdata.json");
        const data = await res.json();
        if (data.thankyouLogo) setLogo(data.thankyouLogo);
      } catch (err) {
        console.error("Error loading JSON config:", err);
      }
    };
    fetchConfig();
  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        padding: "60px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f9fafb"
      }}
    >
      <img src={logo} alt="Success" width="120" />
      <h2 style={{ marginTop: "20px", color: "#16a34a" }}>
        Payment Successful!
      </h2>
      <p style={{ color: "#555", marginTop: "8px" }}>
        Your order has been placed successfully.
      </p>
      <button
        onClick={() => navigate("/")}
        style={{
          marginTop: "25px",
          padding: "10px 20px",
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontWeight: "500"
        }}
      >
        Continue Shopping
      </button>
    </div>
  );
}

export default Thankyou;
